export interface NoraWidgetProps {
  widgetUrl?: string
  initialPrompt?: string
}

export const FORPY_WIDGET_URL = 'https://forpy-ai-RaphaelBarreiro.replit.app'
